import React, {
    Fragment,
    useEffect,
    useRef,
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';
import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import {
    almacenarAction
} from '../../../../actions/almacenarEjercicioActions';

// css
import {
    PantallaInferencia,
    ContenidoLEN39,
    TarjetaLEN39,
    TextoLEN39,
    ImagenLEN39,
    PreguntaLEN39,
    BottomInferencia,
    NavegacionInferencia,
    BotonFlechaInferencia,
    BotonFinalizarInferencia
} from '../../../Css/StyledInferencia';


const instrucciones =
    'Observá la imagen, leé la información y respondé la pregunta.';

const miniInstrucciones =
    'Observá la imagen, leé la información y respondé la pregunta.';


const LEN39 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();


    // =========================================================
    // EJERCICIO ACTUAL
    // =========================================================

    const [count, setCount] =
        useState(1);

    const [comparar, setComparar] =
        useState(null);

    const [indexes, setIndexes] =
        useState(0);

    const [disable, setDisable] =
        useState(false);


    // =========================================================
    // TIEMPOS
    //
    // Guardamos el tiempo acumulado de cada ejercicio.
    //
    // Si vuelve hacia atrás, el nuevo tiempo se suma.
    // =========================================================

    const tiemposRef =
        useRef([
            0,
            0,
            0,
            0,
            0
        ]);

    const inicioTiempoRef =
        useRef(null);


    // =========================================================
    // REDUX
    // =========================================================

    const iniciar = useSelector(
        state =>
            state.ejercicio.iniciar
    );

    const finalizar = useSelector(
        state =>
            state.ejercicio.finalizar
    );

    const id_paciente = useSelector(
        state =>
            state.usuario.id_paciente
    );

    const informacion = useSelector(
        state =>
            state.informacion.info_DB
    );

    const lista_usada = useSelector(
        state =>
            state.informacion.lista_usada
    );

    const sesion = useSelector(
        state =>
            state.ejercicio.sesion
    );


    // =========================================================
    // CONFIGURACIÓN INICIAL
    // =========================================================

    useEffect(() => {

        dispatch(
            setearEjercicioAction(
                'LEN39'
            )
        );

        dispatch(
            setearUrlAnteriorAction(
                'lenguaje/inferencia/'
            )
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================
    // INFORMACIÓN DEL EJERCICIO ACTUAL
    // =========================================================

    useEffect(() => {

        if (
            !Array.isArray(informacion) ||
            informacion.length === 0
        ) {

            return;
        }


        setIndexes(
            informacion.length
        );


        setComparar(
            informacion[
                count - 1
            ]
        );


    }, [
        informacion,
        count
    ]);


    // =========================================================
    // INICIO DEL CRONÓMETRO
    // =========================================================

    useEffect(() => {

        if (
            iniciar &&
            comparar &&
            inicioTiempoRef.current === null
        ) {

            inicioTiempoRef.current =
                Date.now();

        }


        if (!iniciar) {

            inicioTiempoRef.current =
                null;

        }


    }, [
        iniciar,
        comparar
    ]);


    // =========================================================
    // REGISTRAR TIEMPO DEL EJERCICIO ACTUAL
    // =========================================================

    const registrarTiempoActual = () => {

        if (
            inicioTiempoRef.current === null
        ) {

            return;
        }


        const ahora =
            Date.now();


        const segundos =
            (
                ahora -
                inicioTiempoRef.current
            ) / 1000;


        const indice =
            count - 1;


        tiemposRef.current[indice] +=
            segundos;


        inicioTiempoRef.current =
            ahora;
    };


    // =========================================================
    // ANTERIOR
    // =========================================================

    const anterior = (e) => {

        e.preventDefault();


        if (
            disable ||
            count <= 1
        ) {

            return;
        }


        registrarTiempoActual();


        setCount(
            count - 1
        );
    };


    // =========================================================
    // SIGUIENTE
    // =========================================================

    const siguiente = (e) => {

        e.preventDefault();


        if (
            disable ||
            count >= indexes
        ) {

            return;
        }


        registrarTiempoActual();


        setCount(
            count + 1
        );
    };


    // =========================================================
    // FINALIZAR
    // =========================================================

    const terminar = (e) => {

        e.preventDefault();


        if (
            disable ||
            !comparar
        ) {

            return;
        }


        setDisable(
            true
        );


        registrarTiempoActual();


        dispatch(
            finalizarEjercicioAction()
        );
    };


    // =========================================================
    // ALMACENAR
    // =========================================================

    useEffect(() => {

        if (!finalizar) {

            return;
        }


        const tiempoFinal =
            tiemposRef.current.map(
                tiempo =>
                    Math.round(
                        tiempo * 10
                    ) / 10
            );


        const informacionGuardar = {

            config,

            payload: {

                ejercicio:
                    'LEN39',

                errores:
                    0,

                tiempo:
                    tiempoFinal,

                id_paciente,

                lista_usada,

                sesion
            }
        };


        dispatch(
            almacenarAction(
                informacionGuardar
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);


    // =========================================================
    // RENDER
    // =========================================================

    return (

        <Fragment>

            <HeaderEjercicios
                estrellas={true}
                carrito={true}
            />


            {
                iniciar

                    ? (

                        <PantallaInferencia>


                            <ContenidoLEN39>


                                {
                                    comparar && (

                                        <TarjetaLEN39>


                                            <TextoLEN39>

                                                {
                                                    comparar.frase
                                                }

                                            </TextoLEN39>


                                            <ImagenLEN39>

                                                {
                                                    comparar.imagen_url_1 && (

                                                        <img
                                                            src={
                                                                `/img/${comparar.imagen_url_1}.png`
                                                            }
                                                            alt=""
                                                        />

                                                    )
                                                }

                                            </ImagenLEN39>


                                            <PreguntaLEN39>

                                                {
                                                    comparar.pregunta
                                                }

                                            </PreguntaLEN39>


                                        </TarjetaLEN39>

                                    )
                                }


                            </ContenidoLEN39>


                            <BottomInferencia>


                                <BotoneraBottom
                                    miniInstrucciones={
                                        miniInstrucciones
                                    }
                                />


                                <NavegacionInferencia>


                                    <BotonFlechaInferencia
                                        type="button"
                                        disabled={
                                            disable ||
                                            count === 1
                                        }
                                        onClick={
                                            anterior
                                        }
                                        aria-label="Anterior"
                                    >

                                        <span>
                                            ‹
                                        </span>

                                    </BotonFlechaInferencia>


                                    {
                                        count < indexes

                                            ? (

                                                <BotonFlechaInferencia
                                                    type="button"
                                                    disabled={
                                                        disable
                                                    }
                                                    onClick={
                                                        siguiente
                                                    }
                                                    aria-label="Siguiente"
                                                >

                                                    <span>
                                                        ›
                                                    </span>

                                                </BotonFlechaInferencia>

                                            )

                                            : (

                                                <BotonFinalizarInferencia
                                                    type="button"
                                                    disabled={
                                                        disable
                                                    }
                                                    onClick={
                                                        terminar
                                                    }
                                                >

                                                    <img
                                                        alt=''
                                                        src={`/img/icono_avanzar_ninos.png`}
                                                    />

                                                </BotonFinalizarInferencia>

                                            )
                                    }


                                </NavegacionInferencia>


                            </BottomInferencia>


                        </PantallaInferencia>

                    )

                    : (

                        <Instrucciones
                            instrucciones={
                                instrucciones
                            }
                        />

                    )
            }


        </Fragment>
    );
};


export default LEN39;